var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import errorHandler from 'services/connection';
import { pageSize } from '@shared/utils/constants';
import { getCategories as getCategoriesAction, getCategoriesComplete, getCategory as getCategoryAction, getCategoryComplete, noPrimaryCategoryIdProvided, resetCategories } from './actions';
export function getCategory(api, action) {
    var body, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call([api, api.get], "categories/" + action.payload)];
            case 1:
                body = (_a.sent()).body;
                return [4 /*yield*/, put(getCategoryComplete(fromJS(body)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                return [4 /*yield*/, put(errorHandler(error_1, getCategoryComplete, getCategoryAction, action.payload))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function getCategories(api, action) {
    var _a, body, headers, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(action.payload.page === 1 || !action.payload.primaryCategory)) return [3 /*break*/, 2];
                return [4 /*yield*/, put(resetCategories())];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                if (!!action.payload.primaryCategory) return [3 /*break*/, 4];
                return [4 /*yield*/, put(noPrimaryCategoryIdProvided())];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                _b.trys.push([4, 7, , 9]);
                return [4 /*yield*/, call([api, api.get], 'v2/categories', {
                        params: __assign({ pageSize: pageSize }, action.payload),
                    })];
            case 5:
                _a = _b.sent(), body = _a.body, headers = _a.headers;
                return [4 /*yield*/, put(getCategoriesComplete(fromJS(body), headers))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                error_2 = _b.sent();
                return [4 /*yield*/, put(errorHandler(error_2, getCategoriesComplete, getCategoriesAction, action.payload))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function categoryGetWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_CATEGORY', getCategory, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function categoriesGetWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_CATEGORIES', getCategories, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
